import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {getJsonFromUrl} from '../../../../../utils/url';

import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, productActionCreators);

import CheckboxList from '../filterElements/CheckboxList';
import ColorRadios from '../filterElements/ColorRadios';
import NumericSlider from '../filterElements/NumericSlider';
import ShapeIcons from '../filterElements/ShapeIcons';
import StyleIcons from '../filterElements/StyleIcons';
import SettingTypeIcons from '../filterElements/SettingTypeIcons';
import ValuesSlider from '../filterElements/ValuesSlider';

class EngagementFilters extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);

    let urlData = getJsonFromUrl();
    let getData = Object.assign({}, this.props.product.diamondFilters, this.props.product.productFilters, urlData);
    let urlKeys = Object.keys(urlData);
    let getKeys = Object.keys(getData);
    let hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;

    // Default Values
    let diamondsEnabledValue = true;
    let settingsEnabledValue = true;

    if(hasQuerystring && urlData.mode) {

      let modeVal = urlData.mode;
      if(modeVal == 'diamond') {
        settingsEnabledValue = false;
      }
      if(modeVal == 'setting') {
        diamondsEnabledValue = false;
      }
    }

    this.initDiamondFilters = {
      // shape: 'Round,Oval,Cushion',
      // caratMin: 0.50,
      // caratMax: 4.00,
      // color: 'F,G,H,I',
      // clarityMin: 'SI2',
      // clarityMax: 'VS2',
    };

    this.initSettingFilters = {

    };


		this.state = {

      diamondsEnabled: diamondsEnabledValue,
      settingsEnabled: settingsEnabledValue,

      diamondPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
      settingPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),

      diamondPriceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
      diamondPriceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

      budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
      priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
      priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

      shapesOpen: diamondsEnabledValue === true && (getKeys.includes('shape') || diamondsEnabledValue === true),
      shapeValues: getKeys.includes('shape') ? getData['shape'].toLowerCase().split(',') : [],
      
      caratOpen: diamondsEnabledValue === true && (urlKeys.includes('caratMin') || urlKeys.includes('caratMax') || (diamondsEnabledValue === true && settingsEnabledValue === false)),
      caratMin: getKeys.includes('caratMin') ? parseFloat(getData['caratMin']) : 0.50,
      caratMax: getKeys.includes('caratMax') ? parseFloat(getData['caratMax']) : 5.0,

      colorOpen: diamondsEnabledValue === true && urlKeys.includes('color'),
      colorValues: getKeys.includes('color') ? getData['color'].toLowerCase().split(',') : [],

      clarityOpen: diamondsEnabledValue === true && (urlKeys.includes('clarityMin') || urlKeys.includes('clarityMax')),
      clarityMin: getKeys.includes('clarityMin') ? getData['clarityMin'] : 'SI2',
      clarityMax: getKeys.includes('clarityMax') ? getData['clarityMax'] : 'IF',
      clarityValues: ['IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'],

      // certificationOpen: false,

      cutOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax'),
      cutMin: getKeys.includes('cutMin') ? getData['cutMin'] : 'Very Good',
      cutMax: getKeys.includes('cutMax') ? getData['cutMax'] : 'Excellent',
      cutValues: ['Excellent', 'Very Good'],
      cutTranslate: {
        'Very Good': 'VG',
        'Excellent': 'EX',
      },

      designersOpen: getKeys.includes('designers'),
      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,

      // diamondAdvancedOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax') || getKeys.includes('polMin') || getKeys.includes('polMax') || getKeys.includes('symMin') || getKeys.includes('symMax') || getKeys.includes('fluorMin') || getKeys.includes('fluorMax') || getKeys.includes('depthMin') || getKeys.includes('depthMax') || getKeys.includes('tableMin') || getKeys.includes('tableMax'),
      diamondAdvancedOpen: false,

      polishValues: ['Excellent', 'Very Good', 'Good'],
      polishMin: getKeys.includes('polMin') ? getData['polMin'] : 'Good',
      polishMax: getKeys.includes('polMax') ? getData['polMax'] : 'Excellent',
      polishTranslate: {
        'Good': 'GD',
        'Very Good': 'VG',
        'Excellent': 'EX',
      },

      symmetryValues: ['Excellent', 'Very Good', 'Good'],
      symmetryMin: getKeys.includes('symMin') ? getData['symMin'] : 'Good',
      symmetryMax: getKeys.includes('symMax') ? getData['symMax'] : 'Excellent',
      symmetryTranslate: {
        'Good': 'GD',
        'Very Good': 'VG',
        'Excellent': 'EX',
      },

      // fluorescenceValues: ['Very Strong', 'Strong', 'Medium', 'Faint', 'None'],
      fluorescenceValues: ['None', 'Faint', 'Medium', 'Strong', 'Very Strong'],
      fluorescenceMin: getKeys.includes('fluorMin') ? getData['fluorMin'] : 'None',
      fluorescenceMax: getKeys.includes('fluorMax') ? getData['fluorMax'] : 'Very Strong',

      typeOpen: getKeys.includes('settingtype') || settingsEnabledValue === true,
      typeValues: getKeys.includes('settingtype') ? getData['settingtype'].toLowerCase().split(',') : [],

      stylesOpen: getKeys.includes('style') || (diamondsEnabledValue === false && settingsEnabledValue === true),
      styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],

      designersOpen: getKeys.includes('designers'),
      designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,

      metalTypesOpen: getKeys.includes('metal'),
      metalTypesValues: getKeys.includes('metal') ? getData['metal'].toUpperCase().split(',') : null,

      settingAdvancedOpen: getKeys.includes('mmWidthMin') || getKeys.includes('mmWidthMax') || getKeys.includes('continuity'),
      mmWidthMin: getKeys.includes('mmWidthMin') ? getData['mmWidthMin'] : 1.5,
      mmWidthMax: getKeys.includes('mmWidthMax') ? getData['mmWidthMax'] : 4,

      diamondQueryFilters: {},
      settingQueryFilters: {},
    };
	}

	componentDidMount() {
    document.title = 'Diamonds Direct';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.common.registerNavChange && this.props.common.registerNavChange && prevProps.common.registerNavChange != this.props.common.registerNavChange) {

      let urlData = getJsonFromUrl();
      let getData = Object.assign({}, this.props.product.diamondFilters, this.props.product.productFilters, urlData);
      let getKeys = Object.keys(getData);
      let hasQuerystring = Object.entries(getData).length > 0 && getData.constructor === Object;

      // Default Values
      let diamondsEnabledValue = true;
      let settingsEnabledValue = true;

      if(hasQuerystring && getData.mode) {

        let modeVal = getData.mode;
        if(modeVal == 'diamond') {
          settingsEnabledValue = false;
        }
        if(modeVal == 'setting') {
          diamondsEnabledValue = false;
        }
      }

      this.setState({

        diamondsEnabled: diamondsEnabledValue,
        settingsEnabled: settingsEnabledValue,

        diamondPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
        settingPriceOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),

        diamondPriceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
        diamondPriceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

        budgetOpen: getKeys.includes('priceMin') || getKeys.includes('priceMax'),
        priceMin: getKeys.includes('priceMin') ? parseFloat(getData['priceMin']) : 100,
        priceMax: getKeys.includes('priceMax') ? parseFloat(getData['priceMax']) : 500000,

        shapesOpen: diamondsEnabledValue === true && (getKeys.includes('shape') || diamondsEnabledValue === true),
        shapeValues: getKeys.includes('shape') ? getData['shape'].toLowerCase().split(',') : [],
        
        caratOpen: diamondsEnabledValue === true && (getKeys.includes('caratMin') || getKeys.includes('caratMax') || (diamondsEnabledValue === true && settingsEnabledValue === false)),
        caratMin: getKeys.includes('caratMin') ? parseFloat(getData['caratMin']) : 0.50,
        caratMax: getKeys.includes('caratMax') ? parseFloat(getData['caratMax']) : 5.0,

        colorOpen: diamondsEnabledValue === true && (getKeys.includes('color') || (diamondsEnabledValue === true && settingsEnabledValue === false)),
        colorValues: getKeys.includes('color') ? getData['color'].toLowerCase().split(',') : [],

        clarityOpen: diamondsEnabledValue === true && (getKeys.includes('clarityMin') || getKeys.includes('clarityMax') || (diamondsEnabledValue === true && settingsEnabledValue === false)),
        clarityMin: getKeys.includes('clarityMin') ? getData['clarityMin'] : 'SI2',
        clarityMax: getKeys.includes('clarityMax') ? getData['clarityMax'] : 'IF',
        clarityValues: ['SI2', 'SI1', 'VS2', 'VS1', 'VVS2', 'VVS1', 'IF'],

        // certificationOpen: false,

        cutOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax'),
        cutMin: getKeys.includes('cutMin') ? getData['cutMin'] : 'Good',
        cutMax: getKeys.includes('cutMax') ? getData['cutMax'] : 'Excellent',
        cutValues: ['Good', 'Very Good', 'Excellent'],
        cutTranslate: {
          'Good': 'GD',
          'Very Good': 'VG',
          'Excellent': 'EX',
        },

        // diamondAdvancedOpen: getKeys.includes('cutMin') || getKeys.includes('cutMax') || getKeys.includes('polMin') || getKeys.includes('polMax') || getKeys.includes('symMin') || getKeys.includes('symMax') || getKeys.includes('fluorMin') || getKeys.includes('fluorMax') || getKeys.includes('depthMin') || getKeys.includes('depthMax') || getKeys.includes('tableMin') || getKeys.includes('tableMax'),
        diamondAdvancedOpen: false,

        polishValues: ['Fair', 'Good', 'Very Good', 'Excellent'],
        polishMin: getKeys.includes('polMin') ? getData['polMin'] : 'Fair',
        polishMax: getKeys.includes('polMax') ? getData['polMax'] : 'Excellent',
        polishTranslate: {
          'Good': 'GD',
          'Very Good': 'VG',
          'Excellent': 'EX',
        },

        symmetryValues: ['Fair', 'Good', 'Very Good', 'Excellent'],
        symmetryMin: getKeys.includes('symMin') ? getData['symMin'] : 'Fair',
        symmetryMax: getKeys.includes('symMax') ? getData['symMax'] : 'Excellent',
        symmetryTranslate: {
          'Good': 'GD',
          'Very Good': 'VG',
          'Excellent': 'EX',
        },

        // fluorescenceValues: ['Very Strong', 'Strong', 'Medium', 'Faint', 'None'],
        fluorescenceValues: ['None', 'Faint', 'Medium', 'Strong', 'Very Strong'],
        fluorescenceMin: getKeys.includes('fluorMin') ? getData['fluorMin'] : 'None',
        fluorescenceMax: getKeys.includes('fluorMax') ? getData['fluorMax'] : 'Very Strong',

        typeOpen: getKeys.includes('settingtype') || settingsEnabledValue === true,
        typeValues: getKeys.includes('settingtype') ? getData['settingtype'].toLowerCase().split(',') : [],

        stylesOpen: getKeys.includes('style') || (diamondsEnabledValue === false && settingsEnabledValue === true),
        styleValues: getKeys.includes('style') ? getData['style'].toLowerCase().split(',') : [],

        designersOpen: getKeys.includes('designers'),
        designersValues: getKeys.includes('designers') ? getData['designers'].toLowerCase().split(',') : null,

        metalTypesOpen: getKeys.includes('metal'),
        metalTypesValues: getKeys.includes('metal') ? getData['metal'].toUpperCase().split(',') : null,

        settingAdvancedOpen: getKeys.includes('mmWidthMin') || getKeys.includes('mmWidthMax') || getKeys.includes('continuity'),
        mmWidthMin: getKeys.includes('mmWidthMin') ? getData['mmWidthMin'] : 1.5,
        mmWidthMax: getKeys.includes('mmWidthMax') ? getData['mmWidthMax'] : 4,

        diamondQueryFilters: {},
        settingQueryFilters: {},

        lastDiamondReset: Date.now(),
        lastSettingReset: Date.now(),
      });
    }
  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  monitorWidth() {
    
  }

  getContinuityData() {
    return [
      {
        name: 'Half',
        value: 'half',
      },
      {
        name: 'Three-Quarters',
        value: 'threequarters',
      },
      {
        name: 'Eternity',
        value: 'full',
      },
    ];
  }

  getDesignerData() {
    return [
      {
        name: 'Diamonds Direct Designs',
        value: 'dddesigns',
      }, 
      {
        name: 'A Jaffe',
        value: 'ajaffe',
      }, 
      // {
      //   name: 'Amden',
      //   value: 'amden',
      // },
      {
        name: 'Artcarved',
        value: 'artcarved',
      },
      // {
      //   name: 'Benchmark',
      //   value: 'benchmark',
      // },
      {
        name: 'C. Gonshor',
        value: 'cgonshor',
      },
      // {
      //   name: 'Christian Bauer',
      //   value: 'christianbauer',
      // },
      // {
      //   name: 'Christopher Designs',
      //   value: 'christopherdesigns',
      // },
      {
        name: 'Classique Creations',
        value: 'classique',
      },
      {
        name: 'Coast',
        value: 'coast',
      },
      // {
      //   name: 'Diama',
      //   value: 'diana',
      // },
      // {
      //   name: 'FJ Kashi',
      //   value: 'fjkashi',
      // },
      {
        name: 'Fana',
        value: 'fana',
      },
      // {
      //   name: 'Furrer Jacot',
      //   value: 'furrerjacot',
      // },
      // {
      //   name: 'Gabriel & Co.',
      //   value: 'gabrielco',
      // },
      // {
      //   name: 'Goldman',
      //   value: 'goldman',
      // },
      // {
      //   name: 'Gottlieb & Sons',
      //   value: 'gattlieb',
      // },
      // {
      //   name: 'H. Levi & Co.',
      //   value: 'hlevi',
      // },
      // {
      //   name: 'Henri Daussi',
      //   value: 'henridaussi',
      // },
      // {
      //   name: 'Jack Kelege',
      //   value: 'jackkelege',
      // },
      // {
      //   name: 'Jeff Cooper',
      //   value: 'jeffcooper',
      // },
      {
        name: 'Kirk Kara',
        value: 'kirkkara',
      },
      // {
      //   name: 'Mastoloni',
      //   value: 'mastoloni',
      // },
      // {
      //   name: 'Novell',
      //   value: 'novel',
      // },
      // {
      //   name: 'Odelia',
      //   value: 'odelia',
      // },
      // {
      //   name: 'PeJay Creations',
      //   value: 'pejay',
      // },
      // {
      //   name: 'Rebeka',
      //   value: 'rebeka',
      // },
      {
        name: 'Michael M.',
        value: 'michaelm',
      },
      {
        name: 'SES',
        value: 'ses',
      },
      {
        name: 'Simon G.',
        value: 'simong',
      },
      {
        name: 'Sylvie',
        value: 'sylvie',
      },
      {
        name: 'Tacori',
        value: 'tacori',
      },
      // {
      //   name: 'True Romance',
      //   value: 'trueromanace',
      // },
      {
        name: 'Uneek',
        value: 'uneek',
      },
      {
        name: 'Verragio',
        value: 'verragio',
      },
      // {
      //   name: 'Italgen',
      //   value: 'italgen',
      // },
    ];
  }

  getMetalTypeData() {
    return [
      {
        name: 'White Gold',
        value: 'WG',
      },
      {
        name: 'Yellow Gold',
        value: 'YG',
      },
      {
        name: 'Rose Gold',
        value: 'RG',
      },
      {
        name: 'Platinum',
        value: 'PLAT',
      },
    ]
  }

  checkToEnableDiamonds() {
    if(!this.state.diamondsEnabled) {
      this.toggleDiamondSection();
    }
  }

  checkToEnableSettings() {
    if(!this.state.settingsEnabled) {
      this.toggleSettingSection();
    }
  }

  toggleFilterElement(element) {

    if(!element) {
      return;
    }

    if(element == 'budget') {
      this.setState({ budgetOpen: !this.state.budgetOpen });
    } else if(element == 'shape' && this.state.diamondsEnabled) {
      this.setState({ shapesOpen: !this.state.shapesOpen });
    } else if(element == 'carat' && this.state.diamondsEnabled) {
      this.setState({ caratOpen: !this.state.caratOpen });
    } else if(element == 'color' && this.state.diamondsEnabled) {
      this.setState({ colorOpen: !this.state.colorOpen });
    } else if(element == 'clarity' && this.state.diamondsEnabled) {
      this.setState({ clarityOpen: !this.state.clarityOpen });
    } else if(element == 'cut' && this.state.diamondsEnabled) {
      this.setState({ cutOpen: !this.state.cutOpen });
    } else if(element == 'type' && this.state.settingsEnabled) {
      this.setState({ typeOpen: !this.state.typeOpen });
    } else if(element == 'style' && this.state.settingsEnabled) {
      this.setState({ stylesOpen: !this.state.stylesOpen });
    } else if(element == 'designer' && this.state.settingsEnabled) {
      this.setState({ designersOpen: !this.state.designersOpen });
    } else if(element == 'metal' && this.state.settingsEnabled) {
      this.setState({ metalTypesOpen: !this.state.metalTypesOpen });
    } else if(element == 'diamondAdvanced' && this.state.diamondsEnabled) {
      this.setState({ diamondAdvancedOpen: !this.state.diamondAdvancedOpen });
    } else if(element == 'settingAdvanced' && this.state.settingsEnabled) {
      this.setState({ settingAdvancedOpen: !this.state.settingAdvancedOpen });
    } else if(element == 'diamondPrice' && this.state.diamondsEnabled) {
      this.setState({ diamondPriceOpen: !this.state.diamondPriceOpen });
    } else if(element == 'settingPrice' && this.state.settingsEnabled) {
      this.setState({ settingPriceOpen: !this.state.settingPriceOpen });
    }
  }

  getElementClass(element) {

    if(!element) {
      return;
    }

    if(element == 'budget') {
      return this.state.budgetOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'shape') {
      return this.state.shapesOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'carat') {
      return this.state.caratOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'color') {
      return this.state.colorOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'clarity') {
      return this.state.clarityOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'cut') {
      return this.state.cutOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'type') {
      return this.state.typeOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'style') {
      return this.state.stylesOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'designer') {
      return this.state.designersOpen ? 'filterItem longOpen' : 'filterItem';
    } else if(element == 'metal') {
      return this.state.metalTypesOpen ? 'filterItem midOpen' : 'filterItem';
    } else if(element == 'diamondAdvanced') {
      return this.state.diamondAdvancedOpen ? 'filterItem longOpen' : 'filterItem';
    } else if(element == 'settingAdvanced') {
      return this.state.settingAdvancedOpen ? 'filterItem longOpen' : 'filterItem';
    } else if(element == 'diamondPrice') {
      return this.state.diamondPriceOpen ? 'filterItem open' : 'filterItem';
    } else if(element == 'settingPrice') {
      return this.state.settingPriceOpen ? 'filterItem open' : 'filterItem';
    }
  }

  toggleDiamondSection() {

    this.setState({ diamondsEnabled: !this.state.diamondsEnabled }, () => {
      if(this.state.diamondsEnabled === false) {
        this.setState({
          shapesOpen: false,
          caratOpen: false,
          colorOpen: false,
          clarityOpen: false,
          cutOpen: false,
        });
        if(this.state.settingsEnabled === false) {
          this.setState({ settingsEnabled: true }, () => {
            this.filtersUpdated();
          });
        } else {
          this.filtersUpdated();
        }
      } else {
        this.filtersUpdated();
      }
      this.setEngagementMode();
    });
  }

  toggleSettingSection() {

    this.setState({ settingsEnabled: !this.state.settingsEnabled }, () => {
      if(this.state.settingsEnabled === false) {
        this.setState({
          typeOpen: false,
          stylesOpen: false,
          designersOpen: false,
          metalTypesOpen: false,
        });
        if(this.state.diamondsEnabled === false) {
          this.setState({ diamondsEnabled: true }, () => {
            this.filtersUpdated();
          });
        } else {
          this.filtersUpdated();
        }
      } else {
        this.filtersUpdated();
      }
      this.setEngagementMode();
    });
  }

  setEngagementMode() {

    if(this.state.diamondsEnabled && this.state.settingsEnabled) {
      this.props.setMode('mixed');
    } else if(this.state.diamondsEnabled && !this.state.settingsEnabled) {
      this.props.setMode('diamond');
    } else if(!this.state.diamondsEnabled && this.state.settingsEnabled) {
      this.props.setMode('setting');
    } else {
      this.props.setMode('mixed');
    }
  }

  createQuerystring() {
    let pairsArray = [];

    for (const key in this.props.product.diamondFilters) {
      pairsArray.push(key + '=' + this.props.product.diamondFilters[key]);
    }
    return pairsArray.join('&');
  }

  createSettingQuerystring() {

    let pairsArray = [];

    for (const key in this.props.product.productFilters) {
      pairsArray.push(key + '=' + this.props.product.productFilters[key]);
    }
    return pairsArray.join('&');
  }

  filtersUpdated(filterType = null, filterKeys = null, filterValues = null) {

    if(filterType == 'diamonds' || filterType == 'all') {

      let newFilters = {};

      for(let i=0; i < filterKeys.length; i++) {
        if(filterKeys[i] == 'caratMax'  && filterValues[i] >= 5.0) {
          newFilters[filterKeys[i]] = parseFloat(filterValues[i]) * 4;
        } else {
          newFilters[filterKeys[i]] = filterValues[i];  
        }
      }

      this.props.productSaveDiamondQueryFilters(newFilters);
      setTimeout(() => {
        this.props.updateDiamondsMethod(this.createQuerystring());
      }, 150);
    }

    if(filterType == 'settings' || filterType == 'all') {

      let newFilters = {};

      for(let i=0; i < filterKeys.length; i++) {
        newFilters[filterKeys[i]] = filterValues[i];
      }

      newFilters['type'] = 'engagement';

      this.props.productSaveProductQueryFilters(newFilters, 'setting');
      setTimeout(() => {
        this.props.updateMethod(this.createSettingQuerystring());
      }, 150);
    }

    if(filterType == 'settings') {
      this.props.updateDiamondsMethod(this.createQuerystring());
    } else if(filterType == 'diamonds') {

      this.props.productSaveProductQueryFilters({'type': 'engagement'}, 'setting');
      setTimeout(() => {
        this.props.updateMethod(this.createSettingQuerystring());
      }, 150);
      // this.props.updateMethod(this.createSettingQuerystring());
    }

    if(filterType == 'settings') {
      this.props.setMixedResultsTab('setting');
    }

    if(filterType == 'diamonds') {
      this.props.setMixedResultsTab('diamond');
    }
  }

  searchAction() {
    this.filtersUpdated('all', [], []);
    this.props.closeMethod(false);
  }

  resetDiamondFilters() {
    
    this.setState({
      priceMin: 100,
      priceMax: 500000,

      shapeValues: [],

      caratMin: 0.50,
      caratMax: 5.0,

      colorValues: [],

      clarityMin: 'SI2',
      clarityMax: 'IF',

      cutMin: 'Very Good',
      cutMax: 'Excellent',

      polishMin: 'Fair',
      polishMax: 'Excellent',

      symmetryMin: 'Fair',
      symmetryMax: 'Excellent',

      fluorescenceMin: 'None',
      fluorescenceMax: 'Very Strong',
    });

    this.setState({ lastDiamondReset: Date.now() });

    this.props.productResetDiamondQueryFilters();
    setTimeout(() => {
      this.props.updateDiamondsMethod(this.createQuerystring());
    }, 150);
  }

  resetSettingFilters() {
    
    this.setState({
      typeValues: [],

      styleValues: [],

      designersValues: null,

      metalTypesValues: null,

      mmWidthMin: 1.5,
      mmWidthMax: 4,
    });

    this.setState({ lastSettingReset: Date.now() });

    this.props.productResetProductQueryFilters('setting');
    setTimeout(() => {
      this.props.updateMethod(this.createSettingQuerystring());
    }, 150);
  }

  getCutOptions() {
    return [
      {
        name: 'Excellent',
        value: 'EX',
      },
      {
        name: 'Very Good',
        value: 'VG',
      },
    ];
  }

	render() {
		return <div className='EngagementFilters'>
			<div className='rbFilterWrapper'>
        <div className='rbInternalWrapper'>
          <div className={this.state.diamondsEnabled ? 'diamondSection' : 'diamondSection disabled'} onClick={::this.checkToEnableDiamonds}>
            <div className={'headerItem filterItem'}>
              <div className='filterHead'>
                <div className='filterLabel'>
                  <div className='filterValue' onClick={::this.toggleDiamondSection}>Diamond Filters</div>
                  <div className='filterReset' onClick={() => this.resetDiamondFilters()}>
                    Reset
                  </div>
                </div>
                <div className={'filterIconRadio'} onClick={::this.toggleDiamondSection}>
                  {this.state.diamondsEnabled ?
                    <div className='filterIconRadioInner'></div> :
                    null
                  }
                </div>
              </div>
              <div className='filterBody'></div>
            </div>
            <div className={this.getElementClass('shape')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('shape')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Shape</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <ShapeIcons 
                    refreshData={::this.filtersUpdated} 
                    initData={this.state.shapeValues} 
                    resetElement={this.state.lastDiamondReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('carat')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('carat')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Carat</div>
                  <div className='filterReset'>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                    <div className='infoVal'>Diamond carat weight is the measurement of how much a diamond weighs. A metric ‘carat’ is defined as 200 milligrams. Each carat can be subdivided into 100 ‘points’. This allows precise measurements to the hundredth decimal place.</div>
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <NumericSlider
                    minValue={0.50}
                    maxValue={5.00}
                    hasPlus={true}
                    initMinValue={this.state.caratMin}
                    initMaxValue={this.state.caratMax}
                    minKey={'caratMin'}
                    maxKey={'caratMax'}
                    service={'diamonds'}
                    format={'decimal'}
                    scale={'log'}
                    increment={0.01}
                    refreshData={::this.filtersUpdated}
                    resetElement={this.state.lastDiamondReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('color')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('color')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Color</div>
                  <div className='filterReset'>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                    <div className='infoVal'>The diamond color evaluation of most gem-quality diamonds is based on the absence of color. The scale begins with the letter D, representing colorless, and continues, with increasing presence of color to the letter Z.</div>
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <ColorRadios 
                    refreshData={::this.filtersUpdated} 
                    initData={this.state.colorValues}
                    resetElement={this.state.lastDiamondReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('clarity')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('clarity')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Clarity</div>
                  <div className='filterReset'>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                    <div className='infoVal'>The process of creating a diamond in nature can result in a variety of internal characteristics called ‘inclusions’ and external characteristics called 'blemishes'. The diamond clarity scale begins with internally flawless and goes all the way to included.</div>
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <ValuesSlider 
                    valuesData={this.state.clarityValues}
                    refreshData={::this.filtersUpdated}
                    minKey={'clarityMax'}
                    maxKey={'clarityMin'}
                    initMin={this.state.clarityMax}
                    initMax={this.state.clarityMin}
                    service={'diamonds'}
                    inputWidth={'60px'}
                    resetElement={this.state.lastDiamondReset} />
                </div>
              </div>
            </div>

            <div className={this.getElementClass('diamondPrice')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('diamondPrice')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Diamond Price Range</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                    <div className='infoVal'>The process of creating a diamond in nature can result in a variety of internal characteristics called ‘inclusions’ and external characteristics called 'blemishes'. The diamond clarity scale begins with internally flawless and goes all the way to included.</div>
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <NumericSlider
                    minValue={100}
                    maxValue={500000}
                    initMinValue={this.state.diamondPriceMin}
                    initMaxValue={this.state.diamondPriceMax}
                    minKey={'priceMin'}
                    maxKey={'priceMax'}
                    service={'diamonds'}
                    format={'currency'}
                    scale={'log'}
                    increment={100}
                    refreshData={::this.filtersUpdated}
                    resetElement={this.state.lastDiamondReset} />
                </div>
              </div>
            </div>



            <div className={this.getElementClass('diamondAdvanced')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('diamondAdvanced')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Advanced</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <div className={this.props.product.diamondFilters.shape && this.props.product.diamondFilters.shape.indexOf('Round') >= 0 ? 'advancedItemWrapper' : 'advancedItemWrapper disabled'}>
                    <div className='advancedTitle'>
                      <div className='advTitleLabel' style={{ marginBottom: '10px' }}>Cut</div>
                      <div className='advancedInfo'>
                        <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                        <div className='infoVal'>Diamonds are renowned for their ability to transmit light and sparkle so intensely. We often think of a diamond’s cut as shape (round, emerald, pear), but a diamond’s cut grade is really about how well a diamond’s facets interact with light.</div>
                      </div>
                    </div>
                    
                    <div className='advancedControl'>
                      <CheckboxList 
                        label='Cuts'
                        productType='diamonds'
                        dataKey='cut'
                        refreshData={::this.filtersUpdated}
                        checkboxData={this.getCutOptions()}
                        initData={this.state.cutValues}
                        disabled={this.props.product.diamondFilters.shape && this.props.product.diamondFilters.shape.includes('Round') ? false : true}
                        disableAll={true}
                        resetElement={this.state.lastDiamondReset} />
                    </div>
                    <div className='cutNote'>Cut grade applies to round diamonds only</div>
                  </div>
                  <div className='advancedItemWrapper'>
                    <div className='advancedTitle'>
                      <div className='advTitleLabel'>Polish</div>
                      <div className='advancedInfo'>
                        <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                        <div className='infoVal'>Grading for polish quality refers to the overall craftsmanship of the finished diamond. Are the edges sharp? Are the facets smooth and flat? Polishing wheel marks should not be visible without magnification.</div>
                      </div>
                    </div>
                    <div className='advancedControl'>
                      <ValuesSlider 
                        valuesData={this.state.polishValues}
                        refreshData={::this.filtersUpdated}
                        inputWidth={'120px'}
                        minKey={'polMax'}
                        maxKey={'polMin'}
                        initMin={this.state.polishMax}
                        initMax={this.state.polishMin}
                        service={'diamonds'}
                        translations={this.state.polishTranslate}
                        resetElement={this.state.lastDiamondReset} />
                    </div>
                  </div>
                  <div className='advancedItemWrapper'>
                  <div className='advancedTitle'>
                    <div className='advTitleLabel'>Symmetry</div>
                      <div className='advancedInfo'>
                        <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                        <div className='infoVal'>Symmetrical diamonds reflect more light, adding to the overall sparkle. Gemologists review more than 20 different symmetry features in order to grade how perfectly the facets and cut angles align.</div>
                      </div>
                    </div>
                    <div className='advancedControl'>
                      <ValuesSlider 
                        valuesData={this.state.symmetryValues}
                        refreshData={::this.filtersUpdated}
                        inputWidth={'120px'}
                        minKey={'symMax'}
                        maxKey={'symMin'}
                        initMin={this.state.symmetryMax}
                        initMax={this.state.symmetryMin}
                        service={'diamonds'}
                        translations={this.state.symmetryTranslate}
                        resetElement={this.state.lastDiamondReset} />
                    </div>
                  </div>
                  <div className='advancedItemWrapper'>
                    <div className='advancedTitle'>
                      <div className='advTitleLabel'>Fluorescence</div>
                      <div className='advancedInfo'>
                        <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                        <div className='infoVal'>Fluorescence measures the color of the light emitted by a diamond under an ultraviolet light. While diamond professionals often prefer a fluorescence grade of "none",  "faint" or "medium" grades will offer a better value in lower diamond colors.</div>
                      </div>
                    </div>
                    <div className='advancedControl'>
                      <ValuesSlider 
                        valuesData={this.state.fluorescenceValues}
                        refreshData={::this.filtersUpdated}
                        inputWidth={'120px'}
                        minKey={'fluorMin'}
                        maxKey={'fluorMax'}
                        initMin={this.state.fluorescenceMin}
                        initMax={this.state.fluorescenceMax}
                        service={'diamonds'}
                        resetElement={this.state.lastDiamondReset} />
                    </div>
                  </div>
                  <div className='advancedItemWrapper'>
                    <div className='advancedTitle'>
                      <div className='advTitleLabel'>Depth %</div>
                      <div className='advancedInfo'>
                        <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                        <div className='infoVal'>Depth percentage expresses a width to depth ratio for the diamond, and is a key determinant in grading a stone cut.</div>
                      </div>
                    </div>
                    <div className='advancedControl'>
                      <NumericSlider
                        minValue={45}
                        maxValue={86}
                        initMinValue={45}
                        initMaxValue={86}
                        minKey={'depthMin'}
                        maxKey={'depthMax'}
                        service={'diamonds'}
                        format={'integer'}
                        scale={'linear'}
                        increment={1}
                        refreshData={::this.filtersUpdated}
                        resetElement={this.state.lastDiamondReset} />
                    </div>
                  </div>
                  <div className='advancedItemWrapper'>
                  <div className='advancedTitle'>
                      <div className='advTitleLabel'>Table %</div>
                      <div className='advancedInfo'>
                        <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                        <div className={'upInfo infoVal'}>The width of the table (top facet) in relation to the overall diameter of the diamond establishes the diamond table percentage. Too large, and the diamond can appear flat and translucent.</div>
                      </div>
                    </div>
                    <div className='advancedControl'>
                      <NumericSlider
                        minValue={49}
                        maxValue={89}
                        initMinValue={49}
                        initMaxValue={89}
                        minKey={'tableMin'}
                        maxKey={'tableMax'}
                        service={'diamonds'}
                        format={'integer'}
                        scale={'linear'}
                        increment={0.01}
                        refreshData={::this.filtersUpdated}
                        resetElement={this.state.lastDiamondReset} />
                    </div>
                  </div>
                  <div className='advancedItemWrapper' style={{display: 'none'}}>
                    <div className='advancedTitle'>Diamond Price Range</div>
                    <div className='advancedControl'>
                      
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={this.state.settingsEnabled ? 'settingSection' : 'settingSection disabled'} onClick={::this.checkToEnableSettings}>
            <div className={'headerItem filterItem'}>
              <div className='filterHead'>
                <div className='filterLabel'>
                  <div className='filterValue' onClick={::this.toggleSettingSection}>Setting Filters</div>
                  <div className='filterReset' onClick={() => this.resetSettingFilters()}>
                    Reset
                  </div>
                </div>
                <div className={'filterIconRadio'} onClick={::this.toggleSettingSection}>
                  {this.state.settingsEnabled ?
                    <div className='filterIconRadioInner'></div> :
                    null
                  }
                </div>
              </div>
              <div className='filterBody'></div>
            </div>
            <div className={this.getElementClass('type')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('type')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Type</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <SettingTypeIcons 
                    refreshData={::this.filtersUpdated} 
                    initData={this.state.typeValues}
                    resetElement={this.state.lastSettingReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('style')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('style')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Style</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <StyleIcons 
                    searchType={'settings'}
                    refreshData={::this.filtersUpdated} 
                    initData={this.state.styleValues}
                    resetElement={this.state.lastSettingReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('designer')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('designer')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Designer</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <CheckboxList 
                    label='Designers'
                    productType='settings'
                    dataKey='designers'
                    refreshData={::this.filtersUpdated}
                    checkboxData={this.getDesignerData()}
                    initData={this.state.designersValues}
                    resetElement={this.state.lastSettingReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('metal')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('metal')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Metal</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <CheckboxList 
                    label='Metals'
                    productType='settings'
                    dataKey='metal'
                    refreshData={::this.filtersUpdated}
                    checkboxData={this.getMetalTypeData()}
                    initData={this.state.metalTypesValues}
                    resetElement={this.state.lastSettingReset} />
                </div>
              </div>
            </div>
            <div className={this.getElementClass('settingPrice')}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('settingPrice')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Setting Price Range</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                    <div className='infoVal'>The process of creating a diamond in nature can result in a variety of internal characteristics called ‘inclusions’ and external characteristics called 'blemishes'. The diamond clarity scale begins with internally flawless and goes all the way to included.</div>
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <NumericSlider
                    minValue={100}
                    maxValue={500000}
                    initMinValue={100}
                    initMaxValue={this.state.priceMax}
                    minKey={'priceMin'}
                    maxKey={'priceMax'}
                    service={'settings'}
                    format={'currency'}
                    scale={'log'}
                    increment={100}
                    refreshData={::this.filtersUpdated}
                    resetElement={this.state.lastSettingReset} />
                </div>
              </div>
            </div>






            <div className={this.getElementClass('settingAdvanced')} style={{display: 'none'}}>
              <div className='filterHead' onClick={() => this.toggleFilterElement('settingAdvanced')}>
                <div className='filterLabel'>
                  <div className='filterValue'>Advanced</div>
                  <div className='filterReset' style={{display: 'none'}}>
                    <img src='https://ddw2.diamondsdirect.com/img/gallery/filter/info.svg' />
                  </div>
                </div>
                <div className='filterIcon'>+</div>
                <div className='filterIcon openIcon'>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <div className='advancedItemWrapper'>
                    <div className='advancedTitle'>MM Width</div>
                    <div className='advancedControl'>
                      <NumericSlider
                        minValue={1.5}
                        maxValue={4}
                        initMinValue={this.state.mmWidthMin}
                        initMaxValue={this.state.mmWidthMax}
                        minKey={'mmWidthMin'}
                        maxKey={'mmWidthMax'}
                        service={'settings'}
                        format={'integer'}
                        scale={'linear'}
                        increment={0.1}
                        refreshData={::this.filtersUpdated}
                        resetElement={this.state.lastSettingReset} />
                    </div>
                  </div>
                  <div className='advancedItemWrapper' style={{display: 'none'}}>
                    <div className='advancedTitle'>Diamond Continuity</div>
                    <div className='advancedControl'>
                      <CheckboxList 
                        label='Diamond Continuity'
                        productType='settings'
                        dataKey='continuity'
                        refreshData={::this.filtersUpdated}
                        checkboxData={this.getContinuityData()}
                        resetElement={this.state.lastSettingReset} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='budgetSection' style={{display: 'none'}}>
            <div className={'budgetItem ' + this.getElementClass('budget')}>
              <div className='filterHead'>
                <div className='filterLabel'>
                  <div className='filterValue' onClick={() => this.toggleFilterElement('budget')}>Total Price Range</div>
                  <div className='filterReset' onClick={() => this.resetBudgetFilters()}>
                    Reset
                  </div>
                </div>
                <div className='filterIcon' onClick={() => this.toggleFilterElement('budget')}>+</div>
                <div className='filterIcon openIcon' onClick={() => this.toggleFilterElement('budget')}>&mdash;</div>
              </div>
              <div className='filterBody'>
                <div className='controlsWrapper'>
                  <NumericSlider
                    minValue={100}
                    maxValue={500000}
                    initMinValue={this.state.priceMin}
                    initMaxValue={this.state.priceMax}
                    format={'currency'}
                    scale={'log'}
                    increment={10}
                    refreshData={::this.filtersUpdated}
                    resetElement={click => this.resetBudgetFilters = click} />
                </div>
              </div>
            </div>
          </div>
          <div className='submitSection'>
            <button className={'filterSubmitButton dd2ActionButton'} onClick={::this.searchAction}>Search</button>
          </div>
        </div>
      </div>
      <div className='filterSeparation'></div>
		</div>;
	}
}
export default EngagementFilters;

function mapStateToProps(state) {
  return {
    common: state.common,
    product: state.product,
  };
}

export const EngagementFiltersContainer = connect(
  mapStateToProps,
  allActionCreators
)(EngagementFilters);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/filters/EngagementFilters.jsx